<template>
  <div>
    <div class="card mb-0 shadow" v-if="!editar_atividade && !showImpressaoAtividades">
      <div class="card-body" v-if="!nova_atividade">
        <div class="tab-content">
          <div class="animate__animated animate__fadeIn">
            <div class="row">
              <div class="col-12">
                <h4 class="font-weight-bold">Atividades/Evolução</h4>
              </div>
              <div class="col-12">
                <div
                  class="d-flex align-items-center justify-content-between mb-4"
                >
                  <!-- <router-link class="btn btn-primary" to="/dashboard/atividades/add">
									<i class="fas fa-plus-square" />
									{{ $t("Cadastrar") }}
								</router-link> -->
                  <button
                    class="btn btn-primary"
                    @click="nova_atividade = true"
                  >
                    <i class="fas fa-plus-square" />
                    {{ $t("Cadastrar") }}
                  </button>
                  <div v-if="filtro" style="line-height: 24px">
                    {{ filtro }}

                    <b-button
                      :title="$t('Cancelar filtro')"
                      @click="cancelarfiltro()"
                      v-b-tooltip.hover
                      type="button"
                      class="btn-xs mt-2"
                      variant="default"
                    >
                      Cancelar
                    </b-button>
                  </div>
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="input-group mb-3">
                      <b-input
                        :placeholder="$t('Type to search')"
                        class="form-control search-input"
                        type="text"
                        v-model="search"
                        v-on:change="getItens"
                        aria-describedby="input-search"
                      />
                      <div class="input-group-append" role="button">
                        <span class="input-group-text" id="input-search"
                          ><i class="fas fa-search search-icon"
                        /></span>
                      </div>
                    </div>
                    <button class="btn btn-success btn-sm ml-4" @click="print()">
                      Gerar Impressão
                    </button>
                  </div>
                </div>
              </div>
              <load mode="table" v-if="loading" />
              <div v-else class="col-12">
                <b-table
                  :fields="[
                    {
                      key: 'titulo',
                      label: $t('Detalhes'),
                    },
                    {
                      key: 'participantes_array',
                      label: $t('Participantes'),
                    },
                    {
                      key: 'data',
                      label: $t('Data e Hora'),
                    },
                    {
                      key: 'status',
                      label: $t('Status'),
                    },
                    {
                      key: 'actions',
                      label: '',
                      class: 'text-right',
                      thStyle: {
                        width: '95px',
                        minWidth: '95px',
                      },
                    },
                  ]"
                  :items="itemList"
                  :responsive="true"
                  striped
                  hover
                  show-empty
                  small
                  outlined
                  stacked="md"
                  table-class="mb-3"
                >
                  <template v-slot:cell(titulo)="data">
                    Tipo:
                    <strong>
                      <b-link
                        @click="filtroTipo(data.item.tipo_id, data.item.tipo)"
                      >
                        {{ data.item.tipo }}
                      </b-link>
                    </strong>
                    <br />
                    Tema:
                    <strong> {{ data.item.tema }} </strong>
                    <br />
                    Responsável:
                    <strong>
                      <b-link
                        @click="
                          filtroResp(
                            data.item.responsavel.id,
                            data.item.responsavel.name
                          )
                        "
                      >
                        {{ data.item.responsavel.name }}
                      </b-link>
                    </strong>
                    <br />
                    Protocolo:
                    <strong>
                      {{ data.item.protocolo }}
                    </strong>
                  </template>
                  <template v-slot:cell(participantes_array)="data">
                    <strong>
                      <a href="#" @click.prevent="getParticipantes(data.value)">
                        <i class="fas fa-search-plus"></i>
                        Ver todos ({{ data.value.length }})
                      </a>
                    </strong>
                  </template>
                  <template v-slot:cell(data)="data">
                    <strong>{{ data.value | formatDate() }}</strong>
                    <strong>{{ data.item.hora | formatHora() }}</strong>
                  </template>
                  <template v-slot:cell(status)="data">
                    <span v-html="data.item.status_nome"></span>
                  </template>
                  <template v-slot:cell()="data">
                    <!-- <b-button
                                      :title="$t('Editar')"
                                      :to="'/dashboard/atividades/edit/' + data.item.id"
                                      class="px-2 mb-0"
                                      size="xs"
                                      type="button"
                                      v-b-tooltip.hover
                                      variant="success"
                                      v-if="user_id == data.item.user_id"
                                    >
                                      <i class="mdi mdi-square-edit-outline" />
                                    </b-button> -->
                    <button
                      v-if="user_id == data.item.user_id"
                      @click="
                        atividadeSelected = data.item.id;
                        editar_atividade = true;
                      "
                      class="px-2 mb-0 btn btn-sm btn-success"
                    >
                      <i class="mdi mdi-square-edit-outline" />
                    </button>
                    <b-button
                      :title="$t('Visualizar e Imprimir')"
                      :to="'/dashboard/atividades/show/' + data.item.id"
                      class="px-2 mb-0"
                      size="xs"
                      type="button"
                      v-b-tooltip.hover
                      variant="primary"
                      v-else
                    >
                      <i class="mdi mdi-eye" />
                    </b-button>
                  </template>
                  <template v-slot:empty="scope">
                    <div class="text-center my-5">
                      <img
                        :alt="$t('No results')"
                        class="mb-5"
                        src="/img/icons/robot.svg"
                        style="max-height: 165px"
                      />
                      <h3 class="bold">
                        {{ $t("No records found") }}
                      </h3>
                    </div>
                  </template>
                </b-table>

                <div class="row align-items-center">
                  <div class="col-lg-6 col-md-12">
                    <div class="form-group d-inline-flex mb-0">
                      <select
                        class="form-control"
                        style="width: 70px"
                        v-model="perPage"
                        v-on:change="getItens"
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                    <div class="d-inline-flex ml-2">
                      <b-pagination
                        :per-page="perPage"
                        :total-rows="pagination.total"
                        @change="changePage"
                        v-model="page"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                    <div class="float-lg-right">
                      {{ $t("Showing page") }}
                      {{ pagination.currentPage }}
                      {{ $t("of") }}
                      {{ pagination.totalPages }}
                      {{ $t("pages in") }}
                      {{ pagination.total }}
                      {{ $t("records") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ModalVerParticipantes :usuariosparticipantes="participantes" />
          </div>
        </div>
      </div>
      <div v-else class="card-body px-0">
        <div class="tab-content">
          <AddModal
            :familia="0"
            :morph="{
              id: this.$route.params.id,
              type: 'ScfvGrupo',
            }"
            :usuariosvinculados="pessoas"
            @voltar="nova_atividade = false"
            @reload="
              getItens();
              nova_atividade = false;
            "
          />
        </div>
      </div>
    </div>
    <EditarModal
      v-else-if="editar_atividade && !showImpressaoAtividades"
      :usuariosvinculados="pessoas"
      morph_type="ScfvGrupo"
      :morph="true"
      :morph-atividade-id="atividadeSelected"
      @voltar="editar_atividade = false"
      @reload="getItens()"
      @editar="setEditar"
    />
    <ImpressaoAtividadesScfv
      v-else-if="showImpressaoAtividades"
      :morph="{
        id: this.$route.params.id,
      }"
      @voltar="showImpressaoAtividades = false"
    />
  </div>
</template>
<script>
import ModalVerParticipantes from "../../../../../../Atividade/Resources/assets/js/includes/ModalVerParticipantes";
import AddModal from "../../../../../../Atividade/Resources/assets/js/Add";
import EditarModal from "../../../../../../Atividade/Resources/assets/js/Edit";
import ImpressaoAtividadesScfv from "./ImpressaoAtividadesScfv.vue";

export default {
  props: ["item"],
  name: "Atividades",
  metaInfo() {
    return {
      title: this.$i18n.t("Gestão de Atividades"),
    };
  },
  components: {
    ModalVerParticipantes,
    AddModal,
    EditarModal,
    ImpressaoAtividadesScfv,
  },
  data() {
    return {
      familia: {},
      atividadeSelected: "",
      editar_atividade: false,
      nova_atividade: false,
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      itemList: [],
      participantes: [],
      filtro: null,
      user_id: null,
      showImpressaoAtividades: false,
    };
  },
  computed: {
    pessoas() {
      const pessoas = Array.isArray(this.item?.lista_inscritos)
        ? this.item.lista_inscritos
        : [];
        return pessoas
        .filter(Boolean) // remove null/undefined 
        .map(elem => ({
          id: elem?.id ?? null,
          value: `${elem?.nome_completo ?? ''} <b>${elem?.idade_extenso ?? ''}</b>`,
        }));
    }
  },
  mounted() {
    this.getItens();
  },
  methods: {
    getParticipantes(value) {
      this.participantes = value;
      this.$bvModal.show("modalVerParticipantes");
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getItens();
      }
    },
    getItens() {
      this.loading = true;
      axios
        .get("api/dashboard/atividades", {
          params: {
            morph_type: "ScfvGrupo",
            morph_id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroResp: this.responsavel,
            filtroTipo: this.tipo,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.itemList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getItens();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    filtroResp(id, nome) {
      this.responsavel = id;
      this.filtro = "Filtrando por: " + nome;
      this.getItens();
    },
    filtroTipo(id, nome) {
      this.tipo = id;
      this.filtro = "Filtrando por: " + nome;
      this.getItens();
    },
    cancelarfiltro() {
      this.responsavel = null;
      this.tipo = null;
      this.filtro = null;
      this.getItens();
    },
    setEditar(event) {
      this.editar_atividade = false;
      this.atividadeSelected = event.id;
      setTimeout(() => {
        this.editar_atividade = true;

        this.$nextTick(() => {
          this.editar_atividade = true;
        });
      }, 1000);
    },
    print() {
      this.showImpressaoAtividades = true;
    },
  },
};
</script>
